import {
  Box,
  Button,
  // FormControl,
  // FormErrorMessage,
  // FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Stack,
  Text,
} from "@chakra-ui/core";
// import { Field, Formik } from "formik";
import React, { useState } from "react";
// import Yup from 'yup';

// const SignUpSchema = Yup.object().shape({
//     email: Yup.email('Invalid Email').required('Required')
// });

// const DemoForm = props => {
//     const {values, touched, errors, handleChange, handleSubmit } = props;
//     return(
//         <Form onSubmit={handleSubmit}>
//             <Input type="email" onChange={handleChange} value={values.email} name="email"/>
//             {
//                 errors.email && (

//                 )
//             }
//         </Form>
//     )
// }

function SignUp({ isRecruiter, companyType, companyName }) {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  // const [registerValues, setRegisterValues] = useState({
  //     userName: '',
  //     password: ''
  // });

  return (
    <Box p="5">
      <Text fontSize="xl">New Registration</Text>
      <Stack marginY="1em">
        <Input placeholder="Username" />
        <InputGroup>
          <Input
            type={show ? "text" : "password"}
            placeholder="Enter Password"
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        <InputGroup>
          <Input
            type={show ? "text" : "password"}
            placeholder="Confirm Password"
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        {isRecruiter && (
          <>
            <Select placeholder="Select Type of Company" value={companyType}>
              <option>Agency</option>
              <option>Corporate Company</option>
            </Select>
            <Input
              marginY="0.5em"
              placeholder="Company Name"
              value={companyName}
            />
          </>
        )}
      </Stack>
      <Stack>
        <Button>Register</Button>
      </Stack>
      {/* <SimpleGrid minChildWidth="120px" spacing="1em">
        <Button>Log In</Button>
        <Button variant="outline">
        <Image size="20px" src={LinkedIn} />
        Login with LinkedIn
        </Button>
    </SimpleGrid>
    <Stack textAlign="right" marginY="1em">
        <RouterLink style={{ textDecoration: "underline" }} to="">
        Forgot Your Password ?
        </RouterLink>
        <Text textAlign="center" marginY="1em">
        Please write to us at <Link color="#0000b3">info@quiklyy.com</Link> if
        you have face any issues in posting jobs on the site
        </Text>
    </Stack> */}
    </Box>
  );
}

export default SignUp;
